import { inView, animate, scroll, stagger } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const blockHomepageHero = document.querySelector('.block-homepage-hero');

    // Check if the homepage hero block exists
    if (!blockHomepageHero) {
        return;
    }

    const blockHomepageHeroContent        = blockHomepageHero.querySelectorAll('.block-homepage-hero__content');
    const blockHomepageHeroContentHeading = blockHomepageHero.querySelector('.block-homepage-hero__content__heading');
    const blockHomepageHeroContentHeadingWords = blockHomepageHeroContentHeading.querySelectorAll('span'); // All heading words are wrapped in a <span> element.
    const blockHomepageHeroContentHeadingParagraph = blockHomepageHeroContentHeading.querySelectorAll('p'); // Paragraph is wrapped in a <p> element.
    const blockHomepageHeroInterBubble = blockHomepageHero.querySelector('.block-homepage-hero__bubble-interactive');

    // Animate each word to fade in one after another with a stagger.
    animate(blockHomepageHeroContentHeadingWords, 
        { 
            opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
            transform: ['translateY(40px)', 'translateY(0)'], // Slight upward movement.
        },
        { 
            duration: 0.6, // Animation duration.
            delay: stagger(0.15, { startDelay: 0.3 }) // Delay before animation starts and stagger words.
        }
    );
    
    // Animate the larger <p> block after the words are done
    animate(blockHomepageHeroContentHeadingParagraph, 
        { 
            opacity: [0, 1], // Fade in the large text block
            transform: ['translateX(20px)', 'translateX(0)'], // Slide up from below
        },
        { 
            duration: 0.6, // Animation duration.
            delay: 1.25, // Delay so this starts after the words are done.
        }
    );

    // Scroll-triggered animation for blockHomepageHeroContentHeading
    scroll(
        animate(blockHomepageHeroContentHeading, 
            { y: [0, 2000] },  // Move the heading from 0 to -4000px along the Y-axis.
            { ease: "ease-out" } // Easing.
        ),
        {
            offset: ["start -200px", "end end"],
        }
    );

    let curX = 0;
    let curY = 0;
    let tgX = 0;
    let tgY = 0;

    function move() {
        curX += (tgX - curX) / 20;
        curY += (tgY - curY) / 20;
        blockHomepageHeroInterBubble.style.transform = `translate(${Math.round(curX)}px, ${Math.round(curY)}px)`;
        requestAnimationFrame(move);
    }

    // Listen for mousemove events only when inside the blockHomepageHero
    blockHomepageHero.addEventListener('mousemove', (event) => {
        const rect = blockHomepageHero.getBoundingClientRect();
        tgX = event.clientX - rect.left; // Adjust for block's position
        tgY = event.clientY - rect.top;  // Adjust for block's position
    });

    move();
});